// Phase 16.2 — Brand Asset Library.
//
// Centralised, swap-once-update-everywhere registry of Lifted brand marks.
// Until the user uploads real logo files via the asset pipeline, the tags
// below resolve to `null` and consumers fall back to clean text wordmarks.
// When logos arrive, drop their URLs into the LOGO_URLS map and every
// surface listed in BRAND_USAGE will pick them up automatically.

// ----- Logo registry --------------------------------------------------------
//
// Required tags (per Phase 16.2 directive):
//   logo.latm.primary      — Lifted At The Moment master mark
//   logo.ecosystem.primary — Lifted Ecosystem
//   logo.affiliate.primary — Lifted Affiliate
//   logo.supplies.primary  — Lifted Supplies
//   logo.training.primary  — Lifted Training
//
// Leave the value as `null` (or "") until the user uploads the official PNG.
export const LOGO_URLS = {
  "logo.latm.primary":      "https://customer-assets.emergentagent.com/job_lifted-core/artifacts/q3iden8s_4F23A8C0-CE36-463B-BA70-4431FF5C824B.png",
  "logo.ecosystem.primary": "https://customer-assets.emergentagent.com/job_lifted-core/artifacts/mrrcs6q0_9FD0B827-6329-4B7A-A882-DA7FFD998158.png",
  "logo.affiliate.primary": "https://customer-assets.emergentagent.com/job_lifted-core/artifacts/yjxdq3v4_616C6C95-0FF6-4FAD-9919-902FAD955626.png",
  "logo.supplies.primary":  "https://customer-assets.emergentagent.com/job_lifted-core/artifacts/khtz1nqt_49C6879E-36AA-4230-8A4A-723A845ADABF.png",
  "logo.training.primary":  "https://customer-assets.emergentagent.com/job_lifted-core/artifacts/8k67r0e6_AA6AA73D-4645-4144-BEC9-F64384B74B4C.png",
};

// Wordmark fallbacks (Phase 16.2: directive says "use clean text fallback
// only" until the official logo is uploaded — no generic green star/circle
// as the primary identity).
export const WORDMARKS = {
  "logo.latm.primary":      { mark: "LIFTED",  sub: "AT THE MOMENT" },
  "logo.ecosystem.primary": { mark: "LIFTED",  sub: "ECOSYSTEM" },
  "logo.affiliate.primary": { mark: "LIFTED",  sub: "AFFILIATE" },
  "logo.supplies.primary":  { mark: "LIFTED",  sub: "SUPPLIES" },
  "logo.training.primary":  { mark: "LIFTED",  sub: "TRAINING" },
};

// Which surfaces each tag should appear on (Phase 16.2 mapping table).
export const BRAND_USAGE = {
  "logo.latm.primary": [
    "main_shell_sidebar_brand",
    "main_shell_topbar",
    "public_site_header",
    "public_site_footer",
    "storefront_header",
    "admin_shell_brand",
    "account_settings_pages",
  ],
  "logo.ecosystem.primary": [
    "ecosystem_page_header",
    "ecosystem_dashboard_section",
    "ecosystem_diagram_center",
    "mission_control_areas",
  ],
  "logo.affiliate.primary": [
    "affiliate_zone_header",
    "affiliate_dashboard_header",
    "affiliate_training_surfaces",
    "affiliate_product_links_header",
    "commissions_reports_header",
  ],
  "logo.supplies.primary": [
    "supplies_dashboard_header",
    "delivery_pages_header",
    "driver_pages_header",
    "partner_inventory_header",
    "same_day_flow_header",
  ],
  "logo.training.primary": [
    "training_center_header",
    "training_modules_header",
    "training_certifications_header",
    "training_admin_editor",
  ],
};

export function getLogo(tag) {
  return LOGO_URLS[tag] || null;
}

export function getWordmark(tag) {
  return WORDMARKS[tag] || { mark: "LIFTED", sub: "" };
}
